'use client'

import { useDevToken } from '~/lib/hooks'

function DevSession() {
  useDevToken()

  return null
}

export default DevSession
